export default [
  {
    title: "一行一个",
    type: "GoodsOneLineOne"
  },
  {
    title: "一行两个",
    type: "GoodsOneLineTwo"
  },
  {
    title: "一行三个",
    type: "GoodsOneLineThree"
  },
  {
    title: "快速滑动",
    type: "GoodsSlider"
  }
];



// WEBPACK FOOTER //
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/marketingComponents/Seckill/typeOptions.js